import { createFileRoute } from '@tanstack/react-router';

import {
  DEFAULT_INVESTOR_ENTRY_ERROR_REASON,
  INVESTOR_ENTRY_ERROR_REASONS,
  InvestorErrorPage,
  type TInvestorEntryErrorReason,
} from '@/features/investor-entry/public';

type TErrorSearch = { reason: TInvestorEntryErrorReason };

const isKnownReason = (value: unknown): value is TInvestorEntryErrorReason =>
  INVESTOR_ENTRY_ERROR_REASONS.includes(value as TInvestorEntryErrorReason);

const ErrorRoute = () => {
  const { reason } = Route.useSearch();
  return <InvestorErrorPage reason={reason} />;
};

export const Route = createFileRoute('/error')({
  validateSearch: (search: Record<string, unknown>): TErrorSearch => ({
    reason: isKnownReason(search.reason) ? search.reason : DEFAULT_INVESTOR_ENTRY_ERROR_REASON,
  }),
  component: ErrorRoute,
});
